import { convertToBoolean } from 'src/utils/commonUtils'

export const isSkuRestricted = (sku = {}) => {
  const value =
    sku?.skuProperties?.shippingRestricted ??
    sku?.properties?.shippingRestricted ??
    false
  return convertToBoolean(value)
}

export const isAnySkuRestricted = (product = {}) => {
  const headerRestriction = product?.properties?.shippingRestricted
  if (headerRestriction != null && convertToBoolean(headerRestriction)) {
    return true
  }
  const skus = product?.skuList ?? product?.sku ?? []
  return skus.some(sku => isSkuRestricted(sku))
}

export const isNormalProductRestricted = (product = {}) => {
  const headerRestriction = product?.properties?.shippingRestricted
  if (headerRestriction != null && convertToBoolean(headerRestriction)) {
    return true
  }
  const activeSku = product?.selectedSku ?? product?.previousSku ?? {}
  return isSkuRestricted(activeSku)
}

export const isKitProductRestricted = (product = {}) => {
  const headerRestriction = product?.properties?.shippingRestricted
  if (headerRestriction != null && convertToBoolean(headerRestriction)) {
    return true
  }

  const skuKit = product?.skuKit ?? []
  return skuKit.some(subProduct => {
    const selectedSku = subProduct?.selectedSku ?? {}
    return isSkuRestricted(selectedSku)
  })
}

export const isBundleProductRestricted = (product = {}) => {
  const headerRestriction = product?.properties?.shippingRestricted
  if (headerRestriction != null && convertToBoolean(headerRestriction)) {
    return true
  }
  const mandatoryProducts = product?.bundleMandatoryProducts ?? []
  return mandatoryProducts.some(subProduct => {
    const selectedSku = subProduct?.selectedSku ?? {}
    return isSkuRestricted(selectedSku)
  })
}

export const getRestrictedOptionalProducts = (product = {}) => {
  const optionalProducts = product?.bundleOptionalProducts ?? []
  return optionalProducts.filter(subProduct => {
    const selectedSku = subProduct?.selectedSku ?? {}
    return isSkuRestricted(selectedSku)
  })
}
